import api from "../Utils/axios";

export const getDashboardStats = ({ year, viewType = "yearly", month } = {}) => {
  return api.get(`/user/dashboard`, {
    params: {
      year,
      viewType,
      month,
    },
  });
};
